const autoNgTemplateLoaderTemplate1 = require('./azureSidebarContent.html');

import angular from 'angular';

angular.module('portainer.azure').component('azureSidebarContent', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    endpointId: '<',
  },
});
